import { HttpClient, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import {AppComponent} from "./app.component";
import {BrowserModule} from "@angular/platform-browser";
import {AppRoutingModule} from "./app-routing.module";
import {ReactiveFormsModule} from '@angular/forms';
import { RouterModule } from '@angular/router';
import {NgOptimizedImage} from "@angular/common";
import { UiConfirmationDialogComponent } from './shared/ui/confirmation-dialog.component';
import { BottomNavbarComponent } from './bottom-navbar/bottom-navbar.component';
import { authInterceptor } from './services/auth.interceptor';
import { AuthService } from './services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

/** Charge la langue choisie avant le premier rendu afin que les templates ne montrent pas les clés. */
export function initializeTranslations(translate: TranslateService): Promise<unknown> {
  const supportedLanguages = ['en', 'fr'];
  const savedLanguage = localStorage.getItem('lang');
  const browserLanguage = navigator.language.slice(0, 2);
  const language = savedLanguage && supportedLanguages.includes(savedLanguage)
    ? savedLanguage
    : supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en';

  document.documentElement.lang = language;
  translate.setDefaultLang('en');
  return firstValueFrom(translate.use(language));
}

/** Construit le chargeur qui récupère les fichiers de traduction JSON. */
export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgOptimizedImage,
    ReactiveFormsModule,
    BottomNavbarComponent,
    UiConfirmationDialogComponent
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideAppInitializer(() => inject(AuthService).ensureSession()),
    provideAppInitializer(() => initializeTranslations(inject(TranslateService)))
  ]
})
export class AppModule { }
